import { LANE_INDEXES, cellId, parseCellId } from '@cards/engine';
import { defineGameCard, beforeAttack, oncePerRound, roundMarkerStatus, } from '../authoring/index.js';
const DODGE_ROUND_KEY = '@cards/ability/dazzling_lamp/attack_dodge/round';
export const DazzlingLampCard = defineGameCard({
    id: 'dazzling_lamp',
    gameplay: { type: 'UNIT', cost: 2, baseStats: { attack: 2, health: 3 } },
    presentation: {
        name: 'Ослепляющая лампа',
        description: 'Первый раз за раунд перед атакой по Ослепляющей лампе, если в её локации есть свободная ваша ячейка, переставьте Лампу в первую такую ячейку. Атака завершается в освободившейся ячейке без урона.',
        glyph: {
            colors: ['#10213A', '#8A4326', '#F39A24', '#FFF6A3', '#5C2D1A'],
            rows: [
                '.......111111.......',
                '.....1122222211.....',
                '....122333333221....',
                '...12334444443321...',
                '...13443444434431...',
                '...13444344344431...',
                '...13444444444431...',
                '...12334444443321...',
                '....122333333221....',
                '.....1122555511.....',
                '......11125111......',
                '........1251........',
                '........1251........',
                '........1221........',
                '........1221........',
                '........1221........',
                '.......122221.......',
                '......12222251......',
                '.....1225555551.....',
                '....111111111111....',
            ],
        },
    },
    role: 'playable',
    abilities: [
        beforeAttack(oncePerRound({
            abilityId: 'attack_dodge',
            trigger: 'interceptAttack',
            when(ctx, planned) {
                const self = ctx.self;
                if (self?.cellId === undefined
                    || planned.target.kind !== 'unit'
                    || planned.target.instanceId !== self.id)
                    return false;
                const tableId = parseCellId(self.cellId).tableId;
                const side = ctx.q.player(self.controllerId).side;
                return LANE_INDEXES.some((lane) => ctx.q.cell(cellId(tableId, lane, side))?.occupantId === null);
            },
            run(ctx) {
                const self = ctx.self;
                if (self?.cellId === undefined)
                    return { abilityId: 'attack_dodge', avoided: false };
                const tableId = parseCellId(self.cellId).tableId;
                const side = ctx.q.player(self.controllerId).side;
                const destination = LANE_INDEXES
                    .map((lane) => cellId(tableId, lane, side))
                    .find((candidate) => ctx.q.cell(candidate)?.occupantId === null);
                if (destination === undefined)
                    return { abilityId: 'attack_dodge', avoided: false };
                ctx.ops.moveUnit(self.id, destination);
                return { abilityId: 'attack_dodge', avoided: true };
            },
        })),
    ],
    ui: {
        mechanics: ['dodge'],
        publicVars: {
            dodgeRound: { key: DODGE_ROUND_KEY, kind: 'number' },
        },
        statusProviders: [roundMarkerStatus({
                fact: 'dodgeRound',
                id: 'dazzling-lamp-used',
                symbol: '◉',
                label: 'Перемещение использовано',
                description: 'Лампа уже избежала атаки перемещением в этом раунде.',
                tone: 'neutral',
            })],
    },
});
//# sourceMappingURL=dazzling_lamp.js.map